<template>
  <div class="ml-5 mr-5 mt-5">
    <p class="mb-4">{{ $t('to_use_nanacara_for_doctor_you_need_to_be_able_to_access_the_domain') }}</p>
    <p class="mb-4">
      <a href="javascript:;" @click="checkAccess()">{{ $t('access_confirmation') }}</a> <br>
      <span v-if="access_check === true" class="small style-success">{{ $t('accessable') }}</span>
      <span v-else-if="access_check === false" class="small style-error">{{ $t('cannot_access') }}</span>
    </p>
    
    <p v-if="access_check === true" class="mb-4">
      {{ $t('error_check.accessible.block_1') }}
      <a href="javascript:;" @click="moveToContactForm(1)">{{ $t('error_check.accessible.block_2') }}</a>
      {{ $t('error_check.accessible.block_3') }}
    </p>
    <template v-else-if="access_check === false">
      <p>{{ $t('cannot_access_to_domain') }}</p>
      <p style="white-space: pre-wrap; margin-top: -20px;">
        {{ $t('error_check.unaccessible.lan_wifi.block_1') }}<a href="javascript:;" @click="moveToContactForm(2)">{{ $t('error_check.unaccessible.lan_wifi.block_2') }}</a>{{ $t('error_check.unaccessible.lan_wifi.block_3') }} <br>
      </p>
      <p style="white-space: pre-wrap; margin-top: -20px;">
        {{ $t('error_check.unaccessible.mobile_network.block_1') }}<a href="javascript:;" @click="moveToContactForm(3)">{{ $t('error_check.unaccessible.mobile_network.block_2') }}</a>{{ $t('error_check.unaccessible.mobile_network.block_3') }}
      </p>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState({
      access_check: state => state.auth.access_check
    }),
  },
  methods: {
    async checkAccess(){
      await this.$store.dispatch('auth/checkAccess')
    },
    moveToContactForm(caseContact) {
      let content = this.$t('for_investigation_purpose_please_do_not_edit_and_send_this_information')	
      if (caseContact == 1) {
        content += this.$t('dot_accesssible')
      }
      else if (caseContact == 2) {
        content += this.$t('dot_unaccessible')
                +  this.$t('lan_wifi')
      }
      else if (caseContact == 3) {
        content += this.$t('dot_unaccessible')
                +  this.$t('mobile_network')
      }
      this.$store.dispatch('contact/setContactContent', content)
      this.$router.push('contact-form')
    }
  }
};
</script>
<style scoped>
  a {
    color: black;
    text-decoration: underline; 
    font-weight: bold;
  }
  .style-success {
    color: #0099CC;
    font-size: 100%;
    font-weight: bold;
  }
  .style-error {
    color: #e3342f;
    font-size: 100%;
    font-weight: bold;
  }
</style>
